import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import LazyPlaceholder from '../LazyPlaceholder';
import s from './LoadingPlaceholder.scss';
/** What we'll show while we're waiting for the DaEditor chunk to load. */ const LoadingPlaceholder = ()=>{
    const [showLoader, setShowLoader] = useState(false);
    useEffect(()=>{
        /*
      One more note: we give a 25ms window for the animation to have time to spin up, want to start giving
      that feedback before we hit that 100ms breakpoint
    */ const timeout = setTimeout(()=>setShowLoader(true), 75);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        setShowLoader
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LazyPlaceholder, null), /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: classnames(s['loader'], showLoader && s['shown'])
    }));
};
LoadingPlaceholder.displayName = 'LoadingPlaceholder';
export default LoadingPlaceholder;
